import { p as palette } from '../base/color-ec580bc4.js';

const surfaceStyles = {
  backgroundColor: palette.white
};

/*
 * All Surfaces should use this type in order to prevent any style conflicts of nested Surfaces.
 * If one Surface were to override a property that others don't, it can lead to issues.
 */

export { surfaceStyles as s };
//# sourceMappingURL=surface-a180c85c.js.map
